import React from 'react'

import type { Promotion } from '../../../../Promotions.types'
import { isMembershipsPromotion } from '../../../../utils/isMembershipsPromotion'
import { isPromotionMembershipsMultiple } from '../../../../utils/isPromotionMembershipsMultiple'
import { isPromotionMultiple } from '../../../../utils/isPromotionMultiple'
import { isShopPromotion } from '../../../../utils/isShopPromotion'

type PromotionUsageTableCellProps = {
  promotion: Promotion
}

export const PromotionUsageTableCell = ({ promotion }: PromotionUsageTableCellProps) => {
  const renderLimit = () => {
    if (isShopPromotion(promotion)) {
      if (!promotion.limits.maximumUsesNumber) {
        return null
      }

      return (
        <>
          /
          {isPromotionMultiple(promotion)
            ? promotion.limits.maximumUsesNumber * promotion.codes.length
            : promotion.limits.maximumUsesNumber}
        </>
      )
    }

    if (isMembershipsPromotion(promotion)) {
      if (!promotion.limits.limitToSingleUse) {
        return null
      }

      return <>/{isPromotionMembershipsMultiple(promotion) ? promotion.codes.length : 1}</>
    }
  }

  return (
    <>
      {promotion.usageCount}
      {renderLimit()}
    </>
  )
}
